import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const noteToFileApi = createApi({
  baseQuery,
  reducerPath: 'NoteToFileApi',
  endpoints: builder => ({
    getAllNoteToFile: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data, ntf_level, from = -1, size = -1 }) => ({
        url: `${formatString(
          endPoints.NotetoFile.getAll
        )}?study_id=${study_id}&site_id=${site_id}&country=${country}&application=${application}&ntf_level=${ntf_level}${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}
          `,
        method: 'POST',
        body: data
      })
    }),

    getNoteToFile: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, note_to_file_id, ntf_level }) => ({
        url: `${formatString(
          endPoints.NotetoFile.select,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?study_id=${study_id}&site_id=${site_id}&country=${country}&note_to_file_id=${note_to_file_id}&ntf_level=${ntf_level}&application=${application}
          `,
        method: 'GET'
      })
    }),

    createNoteToFile: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, application_section, ntf_level }) => ({
        url: `${formatString(
          endPoints.NotetoFile.create,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&application_section=${application_section}&application_module_section=STUDY LOGS&ntf_level=${ntf_level}`,
        method: 'POST',
        body: data
      })
    }),
    createNewVersionNoteToFile: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, ntf_level, application_section, note_to_file_id }) => ({
        url: `${formatString(
          endPoints.NotetoFile.createNewVersion,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.note_to_file_id, value: note_to_file_id }
        )}?country=${country}&ntf_level=${ntf_level}&application=${application}&application_section=${application_section}&application_module_section=STUDY LOGS`,
        method: 'POST'
      })
    }),
    updateNoteToFile: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, ntf_level, application, application_section }) => ({
        url: `${formatString(
          endPoints.NotetoFile.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&ntf_level=${ntf_level}&application=${application}&application_section=${application_section}&application_module_section=STUDY LOGS`,
        method: 'PUT',
        body: data
      })
    }),

    signNoteToFile: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, ntf_level, application_section }) => ({
        url: `${formatString(
          endPoints.NotetoFile.sign,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&ntf_level=${ntf_level}&application=CTMS&application_section=${application_section}&application_module_section=STUDY LOGS`,
        method: 'PUT',
        body: data
      })
    }),
    NoteToFilePublishToISF: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, application_module_section }) => ({
        url: `${formatString(
          endPoints.NotetoFile.publishToISF,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&application_module_section=${application_module_section}`,
        method: 'POST',
        body: data
      })
    }),
    NoteToFilePublishToETMF: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, application_module_section }) => ({
        url: `${formatString(
          endPoints.NotetoFile.PublishToETMF,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&application_module_section=${application_module_section}`,
        method: 'POST',
        body: data
      })
    })
  })
});

export const {
  useGetAllNoteToFileMutation,
  useLazyGetNoteToFileQuery,
  useCreateNoteToFileMutation,
  useUpdateNoteToFileMutation,
  useSignNoteToFileMutation,
  useCreateNewVersionNoteToFileMutation,
  useNoteToFilePublishToISFMutation,
  useNoteToFilePublishToETMFMutation
} = noteToFileApi;
